
import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { DeleteDataConnectClusterDialogBody, DeleteDataConnectClusterDialogProps, DeleteDataConnectClusterDialogState } from '~src/settings/dataconnect-settings/sections/dataConnectMultiCluster/DeleteDataConnectClusterDialog';
import { IDeleteBaasClusterResult } from '~src/settings/dataconnect-settings/serverApi/requests/DeleteBaasClusterRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';

import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';

export function openDeleteClusterDialog(actionItem: ActionItemInfo, refreshEdgePoolsAndClusters: () => void) {
  const action = (bodyProps: DeleteDataConnectClusterDialogProps, dialogState: DeleteDataConnectClusterDialogState) => {
    return BaasEdgePoolAndCluster.deleteBaasCluster({ poolId: actionItem.poolId, clusterId: actionItem.clusterId, siteId: actionItem.siteId })
      .then((result: IDeleteBaasClusterResult) => {
        refreshEdgePoolsAndClusters();
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsDeleteClusterSuccess({ CLUSTER_NAME: actionItem.clusterName }) });
        }
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        return Promise.resolve({});
      });
  };

  //const nodes: Node[] = Object.values(actionItem.nodes);

  const dialogInstance = openReactActionDialog<DeleteDataConnectClusterDialogProps, DeleteDataConnectClusterDialogState, IResult>({
    title: Messages.dataConnectSiteSettingsDeleteCluster(),
    bodyComponent: DeleteDataConnectClusterDialogBody,
    initialBodyProps: {
      clusterName: actionItem.clusterName,
      hasNodes: actionItem.nodes !== undefined && actionItem.nodes.length > 0,
      nodes: actionItem.nodes,
      hasPools: actionItem.pools !== undefined && actionItem.pools.length > 0,
    },
    initialDialogState: {isPending: false},
    actionName: Messages.deleteMessage(),
    action: action,
    isActionDelete: true,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width375px
  });

  return Promise.resolve(dialogInstance.result);
}